import { combineReducers } from "redux";

import {
    SEARCH_BIAYA_PENGIRIMAN_LOADING,
    SEARCH_BIAYA_PENGIRIMAN_SUCCESS,
    SEARCH_BIAYA_PENGIRIMAN_ERROR,
} from "../actions/biayaPengirimanAction";

const searchBiayaPengirimanLoading = (state = false, action) => {
    switch (action.type) {
        case SEARCH_BIAYA_PENGIRIMAN_LOADING:
            return action.searchBiayaPengirimanLoading;
        default:
            return state;
    }
};

const searchBiayaPengirimanSuccess = (state = false, action) => {
    switch (action.type) {
        case SEARCH_BIAYA_PENGIRIMAN_SUCCESS:
            return action.searchBiayaPengirimanSuccess;
        default:
            return state;
    }
};

const searchBiayaPengirimanError = (state = false, action) => {
    switch (action.type) {
        case SEARCH_BIAYA_PENGIRIMAN_ERROR:
            return action.searchBiayaPengirimanError;
        default:
            return state;
    }
};

const biayaPengiriman = (state = [], action) => {
    switch (action.type) {
        case SEARCH_BIAYA_PENGIRIMAN_SUCCESS:
            return action.biayaPengiriman;
        default:
            return state;
    }
};

const biayaPengirimanReducer = combineReducers({
    searchBiayaPengirimanLoading,
    searchBiayaPengirimanSuccess,
    searchBiayaPengirimanError,
    biayaPengiriman,
});

export default biayaPengirimanReducer;
